import React from 'react';
import { ButtonElevation, ButtonType, ButtonIcon } from '@prisjakt/ui/button';

import type { Variant } from './types';
import { VariantEnum } from './types';

import { StyledAppliedFilterCount, StyledButton, StyledTitle } from './styles';

type Props = {
  className?: string;
  count?: number | string;
  'data-test'?: string;
  icon?: React.ReactElement;
  onToggle: () => void;
  title?: string;
  truncate?: boolean;
  variant?: Variant;
};

const ToggleButton = (props: Props) => {
  const {
    className,
    count,
    'data-test': dataTest,
    icon,
    onToggle,
    title,
    truncate,
    variant = VariantEnum.DEFAULT,
  } = props;

  return (
    <StyledButton
      className={className}
      containerProps={{ 'data-test': dataTest }}
      elevation={ButtonElevation.NONE}
      onClick={onToggle}
      type={
        variant === VariantEnum.OUTLINED
          ? ButtonType.OUTLINED
          : ButtonType.PRIMARY
      }
      $shouldTruncate={Boolean(truncate)}
    >
      {icon && <ButtonIcon>{icon}</ButtonIcon>}
      {title && <StyledTitle>{title}</StyledTitle>}
      {count && count !== 0 ? (
        <StyledAppliedFilterCount buttonVariant={variant}>
          {count}
        </StyledAppliedFilterCount>
      ) : null}
    </StyledButton>
  );
};

export { ToggleButton, VariantEnum };
